import { useI18n } from "@/lib/i18n";

export default function About() {
    const { t } = useI18n();
    const gold = (s) => <span className="text-[#C9A96E]">{s}</span>;

    return (
        <section id="about" data-testid="about-section" className="relative py-28 md:py-40">
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-5 reveal">
                    <span className="eyebrow">{t("about.eyebrow")}</span>
                    <h2 className="font-serif-display text-white text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
                        {t("about.title_a")} <br />
                        <em className="not-italic text-[#C9A96E]">{t("about.title_b")}</em>
                    </h2>
                    <div className="mt-8 h-px w-16 bg-[#C9A96E]" />
                </div>

                <div className="lg:col-span-7 reveal">
                    <p className="text-slate-300/90 text-lg leading-relaxed font-light">
                        {t("about.p1_before")}
                        {gold(t("about.core.property_label"))}, {gold(t("about.core.concierge_label"))}
                        {t("about.p1_and")}
                        {gold(t("about.core.events_label"))}
                        {t("about.p1_after")}
                    </p>
                    <p className="mt-6 text-slate-400 leading-relaxed font-light">{t("about.p2")}</p>

                    <div className="mt-12 grid grid-cols-3 gap-6 md:gap-10">
                        {["property", "concierge", "events"].map((k) => (
                            <div key={k} className="border-l border-[#C9A96E]/30 pl-4">
                                <div className="font-serif-display text-white text-xl md:text-2xl">
                                    {t(`about.core.${k}_label`)}
                                </div>
                                <div className="mt-2 text-xs text-slate-400 tracking-widest uppercase">
                                    {t(`about.core.${k}_sub`)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
